module.exports = __webpack_public_path__ + "img/genre_rock.7c3ecae1.png";